import { Box, Card, Stack } from '@mui/material'
import { memo } from 'react'

import { formatTicks } from '../../util/string.helpers'
import { Label } from '../shared/label'
import TwitterEmbed from './TwitterEmbed'

const TweetItem = ({ postId, totalReward, insertedAt, symbol, theme, t }) => {
  return (
    <Card sx={{ display: 'flex' }}>
      <Stack
        spacing={1}
        sx={{
          flexGrow: 1,
          p: 2
        }}
      >
        <Box
          sx={{
            mb: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          <Label color='primary'>
            {t('earn-via.reward')}: {formatTicks(totalReward)} {symbol}
          </Label>

          <Box
            component='span'
            sx={{ typography: 'caption', color: 'text.disabled' }}
          >
            {t('common.date', { date: insertedAt })}
          </Box>
        </Box>
        <Stack spacing={1} sx={{ flexGrow: 1 }}>
          <TwitterEmbed postId={postId} theme={theme} t={t} />
        </Stack>
      </Stack>
    </Card>
  )
}

export default memo(TweetItem)
